<template>
  <div class="aliases">
    <LinkCount
      v-for="alias in aliases || []"
      :key="alias"
      class="alias"
      :bookmarkId="bookmarkId"
      :link="link">
      {{alias}}
    </LinkCount>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import LinkCount from '@/components/bookmark/LinkCount'

@Component({
  name: 'Aliases',
  props: ['bookmarkId', 'link', 'aliases'],
  components: { LinkCount }
})
class Aliases extends Vue {
  @Prop bookmarkId
  @Prop link
  @Prop aliases
}

export default Aliases
</script>

<style scoped lang="less">
.aliases {
  display: inline-block;
  margin-right: var(--margin--small);
  margin-bottom: var(--margin--tiny);
}

.alias {
  display: inline;
  padding-left: var(--margin--tiny);
  padding-right: var(--margin--tiny);
  border-bottom: 2px solid var(--color-main);

  &:hover {
    border-bottom-color: var(--color-hover);
  }
}
</style>
